module.exports = __webpack_public_path__ + "assets/img/banner2.8412b52f.png";